import { TrendingSection } from "./TrendingSection";

export * from "./TrendingSection";
export default TrendingSection;
